// i18n/config.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import base app translations
import translationsIT from './locales/it.json';
import translationsEN from './locales/en.json';

// Import legal bundle (privacy/terms/cookies)
import legalTranslations from './locales/legal'; // default export

const resources = {
  it: {
    translation: {
      ...translationsIT,        // nav, home, dashboard, ecc.
      ...legalTranslations.it   // legal.*, legal_checkbox.*
    }
  },
  en: {
    translation: {
      ...translationsEN,
      ...legalTranslations.en
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
